import {fromEvent, map, mergeMap, share} from 'rxjs';

/**
 * @param {HTMLInputElement} input
 * @return {(): void}
 */
const valueToLowerCaseIn = (input) => () => {
    // Remember cursor position
    const {selectionStart: cursorStart} = input;

    input.value = input.value.toLowerCase();

    // Set cursor position
    input.setSelectionRange(cursorStart, cursorStart);
};

/**
 * @param {HTMLInputElement} input
 * @return {(type: string)}
 */
const setTypeTo = (input) => (type) => input.type = type;

/**
 * @param {HTMLInputElement} input
 * @return {()}
 */
const selectAllIn = (input) => () => input.setSelectionRange(0, input.value.length);

/**
 * @param {HTMLInputElement} input
 */
export default function filterUppercase(input) {
    if (!input) return;

    const setType = setTypeTo(input);
    const selectAll = selectAllIn(input);
    const valueToLowerCaseInInput = valueToLowerCaseIn(input);
    const inputEvents$ = fromEvent(input, 'input');
    const focusEvents$ = fromEvent(input, 'focus').pipe(share());
    const blurEvents$ = fromEvent(input, 'blur').pipe(share());
    const inputType$ = focusEvents$.pipe(map(event => event.target.type));

    inputType$
        .pipe(
            mergeMap((type) => blurEvents$.pipe(map(() => type)))
        )
        .subscribe(setType);

    focusEvents$.subscribe(() => {
        setType('text');
        selectAll();
    });
    inputEvents$.subscribe(valueToLowerCaseInInput);
}
